import React from 'react';
import CreateEditButton from './reusables/CreateEditButton';
import { useAuthState } from '../../../context/auth';
import { useEnvState } from '../../../context/env';
import { topicsAPI } from '../../../context/topics';
import { useMessageBusDispatch } from '../../../context/messagebus';
import { messageBusUtil } from '../../../context/messagebus';
import { useLog } from '../../hooks/useLog';
const HandlePost = _ref => {
  let {
    type,
    topic,
    reply,
    forceTypeTopic,
    forceTypeReply,
    edit,
    updateTopicPost,
    updateTopicReplies,
    updateTopicOnReplyCreate,
    navigation,
    startNewTopicButtonRef,
    platform,
    slug,
    avatarUrl,
    showUserProfile,
    trackForum,
    onCloseHandler
  } = _ref;
  // TODO: This is just a pass-thru component that does nothing, consolidate with CreateEditButton
  const isEditMode = edit;
  const isTypeTopic = forceTypeTopic || type && type === 'topic' && !forceTypeReply;
  const authState = useAuthState();
  const envState = useEnvState();
  const messageBusDispatch = useMessageBusDispatch();
  const productSlug = envState.product;
  const {
    log
  } = useLog();
  const handleTopicReply = async data => {
    try {
      let response = {};
      if (isEditMode) {
        if (isTypeTopic) {
          var _topic$first, _topic$first$post;
          // update topic title
          // note: displayed title is the first post (the first reply)
          const postId = topic === null || topic === void 0 ? void 0 : (_topic$first = topic.first) === null || _topic$first === void 0 ? void 0 : (_topic$first$post = _topic$first.post) === null || _topic$first$post === void 0 ? void 0 : _topic$first$post.id;
          if (!postId) throw 'topic id not defined';
          response = await topicsAPI.updateReply(envState.base_url, authState.api_key, postId, data);
          updateTopicPost && updateTopicPost(topic.id, response.post);
        } else {
          // edit reply
          response = await topicsAPI.updateReply(envState.base_url, authState.api_key, reply === null || reply === void 0 ? void 0 : reply.id, data);
          updateTopicReplies && updateTopicReplies(response);
        }
      } else {
        // creating a new topic or reply
        // const dispatchType = 'ADD_NEW_REPLY';
        let dispatchType = 'ADD_ITEM_TO_MY_TOPICS';
        // let event = {type: '', deactivate: [], topic_id: null, dispatch_type: ''};
        const event = {};
        event.type = 'topics';
        event.deactivate = [{
          whichList: 'topics',
          message_type: 'new_topic'
        }, {
          whichList: 'replies',
          message_type: 'latest'
        }];
        if (!isTypeTopic) {
          data['topic_id'] = topic !== null && topic !== void 0 && topic.id ? topic === null || topic === void 0 ? void 0 : topic.id : reply === null || reply === void 0 ? void 0 : reply.topic_id;
          dispatchType = 'ADD_ITEM_TO_MY_REPLIES';
          event.type = 'replies';
          event.deactivate = [{
            whichList: 'replies',
            message_type: 'latest'
          }];
        }
        if (isTypeTopic && platform && slug) {
          data['tags'] = [slug, productSlug];
        }

        // set update in progess flag BEFORE making API call that creates topic/reply
        messageBusDispatch({
          type: 'SET_UPDATE_IN_PROGRESS',
          payload: true
        });

        // create topic or reply
        response = await topicsAPI.createTopicReply(envState.base_url, authState.api_key, data);
        log('MessageBus', 'new topic/reply response', response);
        if (response) {
          event.topic_id = response.topic_id;
          event.dispatch_type = dispatchType;
          let payload = messageBusUtil.createPayload({
            reply_id: response.id,
            topic_id: response.topic_id,
            message_type: dispatchType
          });

          // add topic or reply item, then add event indicating this post was made by current user
          messageBusDispatch({
            type: dispatchType,
            payload: payload
          });
          messageBusDispatch({
            type: 'ADD_EVENT',
            payload: event
          });
          trackForum && trackForum({
            interaction: isTypeTopic ? 'topic' : 'reply'
          });
        }
        updateTopicReplies && updateTopicReplies(response);
      }
      return response;
    } catch (err) {
      console.log('Error while handling post', err);
      return {};
    }
  };
  return /*#__PURE__*/React.createElement(CreateEditButton, {
    type: type,
    isTypeTopic: isTypeTopic,
    topic: topic,
    reply: reply,
    edit: isEditMode,
    handleTopicReply: handleTopicReply,
    navigation: navigation,
    startNewTopicButtonRef: startNewTopicButtonRef,
    platform: platform,
    avatarUrl: avatarUrl,
    showUserProfile: showUserProfile,
    onCloseHandler: onCloseHandler
  });
};
export default HandlePost;
//# sourceMappingURL=HandlePost.js.map